import { ReactNode } from 'react';

import { FooterNav, NavBar, Wrapper } from '../Common/Layout';

interface ClaimLayoutProps {
  children?: ReactNode;
}

export const ClaimLayout = ({ children }: ClaimLayoutProps) => (
  <Wrapper>
    <NavBar />

    {children}

    <FooterNav hideAtletaMission />
  </Wrapper>
);

export default undefined;
